import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=c160872c&"
import script from "./ImageView.vue?vue&type=script&lang=ts&"
export * from "./ImageView.vue?vue&type=script&lang=ts&"
import style0 from "./ImageView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports